import isNil from 'lodash/isNil'
import isObject from 'lodash/isObject'

import * as PoziUtils from 'api/utils'

/**
 * GetPropertiesLabel
 */
export default function (layerConf, props) {
  const titleid = layerConf?.titleid

  // console.debug('GetPropertiesLabel', titleid, layerConf, props)

  if (isNil(layerConf) || isNil(props) || !isObject(props)) {
    console.log('Invalid layer or properties object!')
    return null
  }

  let label
  let labelField

  // First try to find the label field from config.spatial.label
  const spatialLabel = layerConf.config?.spatial?.label || ''
  if (spatialLabel) {
    labelField = PoziUtils.findPropName(props, spatialLabel)
  }

  // If that field does not exist, try to fall back to the deprecated field titleAttribute
  if (!labelField) {
    const titleAttribute = layerConf.titleAttribute || ''
    labelField = titleAttribute && PoziUtils.findPropName(props, titleAttribute)
  }

  if (!labelField) {
    // console.log('GetPropertiesLabel - could not find label field.', titleid, layerConf, props)
  } else {
    label = props[labelField]
  }

  if (isNil(label)) {
    // Report missing label to GA but not for What's Here layers
    //
    // DISABLED for now as it sends off too many events to Google when hovering over
    // a feature
    // if (titleid !== 'whatshere') {
    //   PoziUtils.gtag({
    //     category: 'data',
    //     status: 'warning',
    //     identifier: titleid,
    //     action: 'Label not found',
    //     additionalInfo: `No label found for a feature on layer ${titleid}`
    //   })
    // }

    return label
  }

  return String(label)
}
